<template>
  <div class="drag_interview">
    <div class="drag_top">
      <div class="top_left">
        <div class="title ellipsis" style="maxWidth:180px" :title="intvGroupTitle + ' - ' + intvLink">{{
            intvGroupTitle
          }} - {{ intvLink }}
        </div>
        <div class="time_range" style="margin-left: 8px" v-if="timeRange">{{ timeRange }}</div>
        <div class="total_num">共{{ interRoomNum }}个面试间，已分配{{ interviewerNum }}位面试官</div>
      </div>
      <div class="top_right cursor_pointer" @click="reassignRoom"><span class="kdfont kdfont-shanchu"></span>清空并重新分配
      </div>
    </div>
    <div class="drag_content_box">
      <div class="drag_content">
        <div class="room_area" v-for="(roomItem,roomIndex) in roomConfig">
          <div class="room_content" :class="{'room_check':!roomItem.intvers.length && isCheck}">
            <div class="room_info">
              <i class="kdfont kdfont-zhuyefangzi2"></i>
              <span class="ellipsis" style="width: 50px" :title="roomItem.intvRoomName">{{
                  roomItem.intvRoomName
                }}</span>
            </div>
            <div class="inter_list">
              <draggable
                  v-model="roomItem.intvers"
                  group="intvroom"
                  animation="100"
                  filter=".forbid"
                  dragClass="dragClass"
                  ghostClass="ghostClass"
                  chosenClass="chosenClass"
                  :move="onMove"
                  @end="onEnd"
                  @start="onStart"
              >
                <transition-group tag="span">
                  <div class="inter_info" v-for="(interItem,interIndex) in roomItem.intvers" :key="interItem.id">
                    <i class="kdfont kdfont-wode3"></i><span class="ellipsis" style="width: 40px"
                                                             :title="interItem.name">{{
                      interItem.name
                    }}</span>
                    <div class="master" v-show="interItem.master"><span>主</span></div>
                    <div class="op_setMaster cursor_pointer" v-show="!dragState && !interItem.master"
                         @click.stop.prevent="setMaster(roomItem.intvers,interIndex)"><span>主</span></div>
                    <div class="op_delete cursor_pointer" v-show="!dragState"
                         @click.stop.prevent="deleteIntver(roomItem.intvers,interIndex)">
                      <span></span></div>
                  </div>
                  <div class="inter_info forbid inter_info_add cursor_pointer" key="addnew"
                       v-if="roomItem.intvers.length < 30" @click="addIntver(roomIndex)">
                    <i class="kdfont kdfont-zengjia3"></i>添加
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
          <el-popconfirm
              v-if="roomItem.intvers && roomItem.intvers.length"
              :popper-class="'popConfirm'"
              :hide-icon="true"
              title="删除面试间连同面试官一并删除，确认删除？"
              @confirm="deleteRoom(roomConfig,roomIndex)"
          >
            <i class="kdfont kdfont-guanbi7 cursor_pointer"
               :style="{'visibility':roomItem.appfiles && roomItem.appfiles.length ? 'hidden':'inherit'}"
               slot="reference"></i>
          </el-popconfirm>
          <i class="kdfont kdfont-guanbi7 cursor_pointer"
             :style="{'visibility':roomItem.appfiles && roomItem.appfiles.length ? 'hidden':'inherit'}"
             v-if="!(roomItem.intvers && roomItem.intvers.length)"
             @click="deleteRoom(roomConfig,roomIndex)"></i>

        </div>
      </div>
    </div>
    <div class="room_area_add cursor_pointer" v-if="interRoomNum < 100" @click="addRoom">
      <i class="kdfont kdfont-zengjia3"></i>
      添加面试间
    </div>
  </div>
</template>
<script>
//导入draggable组件
import draggable from "vuedraggable";

export default {
  //注册draggable组件
  components: {
    draggable,
  },
  props: {
    cusParam_configData: Object,
    cusParam_save: Number,
    cusParam_cancle: Number,
    cusParam_savetosite: Number
  },
  watch: {
    cusParam_configData: function (obj) {
      if (!obj) {
        return;
      }
      this.intvGroupTitle = obj.intvGroupNames ? obj.intvGroupNames.join('，') : "";
      this.intvLink = obj.intvLink;
      this.timeRange = obj.timeRange;
      // 完善结构并赋值初始分配结构
      this.roomConfig = this.perfectConfigData(obj.configList);
    },
    cusParam_save: function (num) {
      if (!num) {
        return;
      }
      this.submitConfigData("form_submit");
    },
    cusParam_savetosite: function (num) {
      if (!num) {
        return;
      }
      this.submitConfigData("form_submittosite");
    },
    cusParam_cancle: function (num) {
      if (!num) {
        return;
      }
      this.cancleConfig();
    }
  },
  computed: {
    interRoomNum() {
      return this.roomConfig ? this.roomConfig.length : 0;
    },
    interviewerNum() {
      return this.roomConfig.reduce((pre, cur) => {
        return pre + cur.intvers.length;
      }, 0)
    }
  },
  data() {
    return {
      roomConfig: [],
      intvGroupTitle: '',
      intvLink: '',
      timeRange: null,
      curAddIntverOfRoomIndex: null,
      isCheck: false,
      scrollTimer: null,
      scrollSpeed: 0,
      dragState: false
    };
  },
  mounted() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    // document.body.onmousemove = function (event){
    //   console.log(888)
    // }
    //去除滚动条
    this.hideScrollBar();
  },
  methods: {
    //开始拖拽事件
    onStart() {
      console.log("start")
      this.dragState = true;
      //注册鼠标超出时间选择窗口的行为事件
      let _this = this;
      // document.addEventListener('mousemove', _this.mousemoveBody);
    },
    //拖拽结束事件
    onEnd() {
      console.log("end");
      this.dragState = false;
      for (let indexRoom = 0, lenRoom = this.roomConfig.length; indexRoom < lenRoom; indexRoom++) {
        let roomObj = this.roomConfig[indexRoom];
        for (let indexIntv = 0, lenIntv = roomObj.intvers.length; indexIntv < lenIntv; indexIntv++) {
          let intvObj = roomObj.intvers[indexIntv];
          intvObj.master = indexIntv === 0;
        }
      }
      console.log(this.roomConfig)
      //清除鼠标超出时间选择窗口时的轮询滚动定时器
      clearInterval(this.scrollTimer);
      //解绑外部抬起鼠标按钮及鼠标超出时间选择窗口的行为事件
      let _this = this;
      // document.removeEventListener('mousemove', _this.mousemoveBody);
    },
    //move回调方法
    onMove(e, originalEvent) {
      // console.log(this.roomConfig)
      // console.log(e);
      // console.log(originalEvent);
      let condition1 = e.relatedContext.list.length && e.relatedContext.element !== undefined;
      let condition2 = e.relatedContext.list.length === 0 && e.willInsertAfter === false;
      if (condition1 || condition2) {
        return true;
      }
      return false;
    },
    onAdd(e, originalEvent) {

    },
    /**
     * 设置为主面试官
     * @param intverList 当前房间面试官集合
     * @param intverIndex 当前操作面试官序号
     */
    setMaster(intverList, intverIndex) {
      intverList[0].master = false;
      intverList[intverIndex].master = true;
      let intverObj = intverList[intverIndex];
      intverList.splice(intverIndex, 1);
      intverList.unshift(intverObj);
    },

    /**
     * 删除面试官
     * @param intverList 当前房间面试官集合
     * @param intverIndex 当前被删除面试官序号
     */
    deleteIntver(intverList, intverIndex) {
      intverList.splice(intverIndex, 1);
      if (intverList.length > 0) {
        intverList[0].master = true;
      }
    },

    /**
     * 删除房间
     * @param intverList 房间集合
     * @param intverIndex 当前被删除房间序号
     */
    deleteRoom(roomConfig, roomIndex) {
      roomConfig.splice(roomIndex, 1);
    },

    /**
     * 新增面试官
     * @param index 当前操作房间序号
     */
    addIntver(index) {
      this.curAddIntverOfRoomIndex = index;
      let newConfigData = this.generateNewConfigData();
      newConfigData.curOpRoomIndex = index;
      this.invoke("form_addIntver", newConfigData);
      console.log(this.generateNewConfigData())
    },

    /**
     * 新增面试间
     */
    addRoom() {
      this.invoke("form_addRoom", this.generateNewConfigData())
    },

    /**
     * 清空并重新分配
     */
    reassignRoom() {
      this.invoke("form_reassign", this.generateNewConfigData())
    },

    /**
     * 提交场次配置信息
     */
    submitConfigData(formParamStr) {
      this.isCheck = true;
      let isAllRoomHasIntver = true;
      for (let index = 0, len = this.roomConfig.length; index < len; index++) {
        if (this.roomConfig[index].intvers.length === 0) {
          isAllRoomHasIntver = false;
        }
      }
      if (isAllRoomHasIntver) {
        this.invoke(formParamStr, this.generateNewConfigData())
      } else {
        this.invoke('form_showTips', this.generateNewConfigData());
      }
    },

    /**
     * 取消场次资源配置
     */
    cancleConfig() {
      this.invoke("form_cancle", this.generateNewConfigData())
    },

    /**
     * 生成最新的房间配置信息对象
     * @returns {Object} 房间配置信息对象
     */
    generateNewConfigData() {
      let configData = this.cusParam_configData;
      configData.configList = this.roomConfig;
      return configData;
    },

    /**
     * 完善资源分配数据结构
     */
    perfectConfigData(configList) {
      if (!configList) {
        configList = [];
      }
      for (let index = 0, len = configList.length; index < len; index++) {
        if (!configList[index].intvers) {
          configList[index].intvers = [];
        } else {
          for (let intvIndex = 0, intvLen = configList[index].intvers.length; intvIndex < intvLen; intvIndex++) {
            let intverItem = configList[index].intvers[intvIndex];
            intverItem.master = intvIndex === 0;
          }
        }
      }
      return configList;
    },

    /**
     * 去除滚动条
     */
    hideScrollBar() {
      let el = $(".drag_interview .drag_content");
      let scrollWidth = el[0].offsetWidth - el[0].clientWidth;
      el.css("marginRight", "-" + scrollWidth + "px")
    },
    mousemoveBody(e) {
      let body_startY = $(".drag_interview .drag_content")[0].getBoundingClientRect().y;
      let body_endY = body_startY + $(".drag_interview .drag_content").height();
      console.log(body_startY, body_endY)
      let _this = this;
      if (e.clientY > (body_endY + 5)) {
        this.scrollSpeed = e.clientY - body_endY;
        if (!this.scrollTimer) {
          this.scrollTimer = setInterval(() => {
            let el = $(".drag_interview .drag_content");
            el.scrollTop(el.scrollTop() + _this.scrollSpeed)
          }, 100)
        }
      } else if (e.clientY < (body_startY - 5)) {
        this.scrollSpeed = e.clientY - body_startY;
        if (!this.scrollTimer) {
          this.scrollTimer = setInterval(() => {
            let el = $(".drag_interview .drag_content");
            el.scrollTop(el.scrollTop() + _this.scrollSpeed)
          }, 100)
        }
      } else {
        if (this.scrollTimer) {
          clearInterval(this.scrollTimer);
          this.scrollTimer = null;
        }
      }
    },
  },
};
</script>
<style lang="less">
/*定义要拖拽元素的样式*/
.drag_interview {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 16px 24px;
  flex-grow: 0;
  flex-shrink: 0;
  height: 100%;

  .ellipsis {
    overflow-x: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cursor_pointer {
    cursor: pointer !important;
  }

  .drag_top {
    padding-bottom: 16px;
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .top_left {
      display: flex;
      flex-direction: row;
      align-items: center;

      .time_range, .title {
        font-size: 14px;
        color: #333333;
        font-weight: 600;
      }

      .total_num {
        margin-left: 16px;
        font-size: 12px;
        color: #666666;
      }
    }

    .top_right {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: var(--theme-color);

      .kdfont-shanchu {
        margin-right: 5px;
      }
    }
  }

  .drag_content_box {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-grow: 0;
    flex-shrink: 1;
    overflow-x: hidden;
  }

  .drag_content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-shrink: 1;
    flex-grow: 1;
    overflow-y: scroll;

    .room_area {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-shrink: 0;
      flex-grow: 0;
      margin-bottom: 10px;

      .room_content {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        flex-shrink: 1;
        flex-grow: 1;
        border: 1px solid #E5E5E5;
        border-radius: 1px;
      }

      .room_check {
        border: 1px solid #FB2323;
      }

      .kdfont-guanbi7 {
        flex-shrink: 0;
        flex-grow: 0;
        color: #b2b2b2;
        margin-left: 9px;

        &:hover {
          color: #FB2323;
        }
      }

      .room_info {
        background: #FAFAFA;
        color: #333333;
        width: 96px;
        border-right: 1px solid #E5E5E5;
        flex-grow: 0;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .kdfont-zhuyefangzi2 {
          color: #404040;
          font-size: 16px;
          margin-right: 5px;
        }
      }

      .inter_list > div {
        width: 100%;
        height: 100%;
      }

      .inter_list > div > span {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }

      .inter_list {
        padding: 10px 0 0 10px;
        flex-grow: 1;
        flex-shrink: 1;

        .inter_info:hover .op_setMaster {
          display: flex;
        }

        .inter_info:hover .op_delete {
          display: flex;
        }

        .inter_info {
          width: 88px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid #E5E5E5;
          border-radius: 1px;
          color: #212121;
          margin: 0 10px 10px 0;
          display: flex;
          position: relative;
          align-items: center;
          justify-content: center;
          cursor: default;

          .kdfont-wode3 {
            margin-right: 6px;
            color: #666;
            font-size: 16px;
          }

          .master {
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--theme-color);
            color: #FFF;
            position: absolute;
            left: 0;
            top: 0;

            span {
              transform: scale(0.833);
            }
          }

          .op_setMaster {
            position: absolute;
            top: -7px;
            right: 15px;
            width: 14px;
            height: 14px;
            padding-bottom: 2px;
            border-radius: 50%;
            background: #276FF5;
            color: #fff;
            align-items: center;
            justify-content: center;
            display: none;

            span {
              transform: scale(0.733);
            }
          }

          .op_delete {
            position: absolute;
            top: -7px;
            right: -7px;
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background: #FB2323;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            display: none;

            span {
              height: 1px;
              width: 8px;
              background: #fff;
            }
          }
        }

        .inter_info_add {
          border: 1px solid var(--theme-color);
          color: var(--theme-color);
          background: #FFFFFF;

          .kdfont-zengjia3 {
            font-size: 13px;
            margin-right: 6px;
          }
        }
      }
    }
  }

  .room_area_add {
    height: 40px;
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--theme-color-level1);
    color: var(--theme-color);
    border: 1px dashed var(--theme-color);

    .kdfont-zengjia3 {
      font-size: 13px;
      margin-right: 6px;
    }
  }

}

.ghostClass {
  background: #FAFAFA !important;
}

.chosenClass {
  border: 1px solid var(--theme-color) !important;
  opacity: 1 !important;
}

.dragClass {
  background-color: #fafafa !important;
  border: 0 !important;
  opacity: 1 !important;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08) !important;
  outline: none !important;
  background-image: none !important;

  div {
    opacity: 1 !important;
  }
}

.popConfirm {
  .el-popconfirm__main {
    margin-bottom: 5px;
  }

  .el-popconfirm__action {
    .el-button--text {
      color: var(--theme-color);
    }

    .el-button--primary {
      background-color: var(--theme-color);
      border-color: #FFFFFF;
      position: relative;

      &:before {
        content: "";
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        position: absolute;
        background-color: hsla(0, 0%, 100%, .35);
        display: none;
      }

      &:hover:before {
        display: block;
      }
    }
  }
}
</style>
